import type { HeroBannerPromoCardType } from 'bundles/front-page/redesign-modules/hero-banner/HeroBannerPromoCard';

import C4BDesktop from 'images/front-page/C4BDesktop.png';
import C4BMobile from 'images/front-page/C4BMobile.png';
import JoinForFreeDesktop from 'images/front-page/JoinForFreeDesktop.png';
import JoinForFreeMobile from 'images/front-page/JoinForFreeMobile.png';
import PythonDesktop from 'images/front-page/PythonDesktop.png';
import PythonMobile from 'images/front-page/PythonMobile.png';
import WesTentpoleDesktop from 'images/front-page/WesTentpoleDesktop.png';
import WesTentpoleMobile from 'images/front-page/WesTentpoleMobile.png';

import _t from 'i18n!nls/front-page';

const getPredefinedPromos = (): Record<string, HeroBannerPromoCardType> => ({
  joinForFree: {
    backgroundColor: 'tertiary-yellow-xweak',
    headline: _t('Start, switch, or advance your career'),
    description: _t('Grow with 10,000+ courses from top organizations'),
    desktopImage: {
      url: JoinForFreeDesktop,
      width: 330,
      height: 304,
    },
    mobileImage: {
      url: JoinForFreeMobile,
      width: 232,
      height: 138,
    },
    cta: {
      target: 'sign-in-modal',
      label: _t('Join For Free'),
      variant: 'primary',
    },
  },
  c4b: {
    backgroundColor: 'neutral-grey-weak',
    headline: _t('Drive your business forward and empower your talent'),
    description: _t('Train teams with industry-leading experts'),
    desktopImage: {
      url: C4BDesktop,
      width: 330,
      height: 304,
    },
    mobileImage: {
      url: C4BMobile,
      width: 232,
      height: 138,
    },
    cta: {
      target:
        'business?utm_campaign=website&utm_content=banner-from-B2C-home-try-business&utm_medium=coursera&utm_source=enterprise&utm_term=treatment',
      label: _t('Try Coursera for Business'),
      variant: 'primary',
    },
  },
  wesTentpole: {
    backgroundColor: 'dark-blue',
    headline: _t('Train your team in top skills and join 4,500+ teams worldwide'),
    desktopImage: {
      url: WesTentpoleDesktop,
      width: 330,
      height: 304,
    },
    mobileImage: { url: WesTentpoleMobile, width: 232, height: 276 },
    cta: {
      target:
        '/business/teams?promoCode=aug30-2025&utm_medium=coursera&utm_source=home-page&utm_campaign=2025-aug-promo&utm_content=hero-cta&utm_term=treatment',
      label: _t('Save on Teams'),
    },
  },
  promoCert: {
    backgroundColor: 'blue',
    headline: _t('Become a Python developer with skills from Microsoft'),
    description: _t('Get job-ready in less than 4 months'),
    desktopImage: {
      url: PythonDesktop,
      width: 330,
      height: 304,
    },
    mobileImage: {
      url: PythonMobile,
      width: 232,
      height: 138,
    },
    cta: {
      target:
        'professional-certificates/microsoft-python-developer?utm_medium=coursera&utm_source=lohphero&utm_campaign=tq32025',
      label: _t('Enroll now'),
    },
  },
});

export default getPredefinedPromos;
